/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PaymentErrorResultEnum {
  Error = 'Error',
  CancelledByUser = 'CancelledByUser',
  Expired = 'Expired',
}
